// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-card {
  margin: auto;
  transition: 0.6s;
  box-shadow: none !important;
  border: 0.063rem solid #c9d3cc;
}
@media (max-width: 768px) {
  .loan-card .gyramais-information {
    margin-bottom: 0.875rem;
  }
}
.loan-card .header-left-side {
  display: flex;
  align-items: center;
}
.loan-card .header-left-side .title-container {
  margin-right: 1rem;
}
.loan-card .header-right-side .schedule-installments-button-icon {
  font-size: 1.4rem;
}
.loan-card .info-row {
  align-items: flex-end;
}
.loan-card .buttons-area {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .loan-card .buttons-area {
    justify-content: center;
  }
  .loan-card .buttons-area .ant-row {
    width: 100%;
  }
  .loan-card .buttons-area .ant-col {
    flex: 0 0 100%;
  }
  .loan-card .buttons-area .ant-col:last-child {
    margin-bottom: 1rem;
  }
  .loan-card .buttons-area .section-divider {
    margin: 0.5rem 0rem;
    margin-top: 1rem;
  }
  .loan-card .buttons-area .gyramais-btn {
    width: 100% !important;
  }
}
.loan-card .information-badesc-suffix {
  margin-left: 0.6rem;
}
.loan-card .actions-area {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .loan-card .actions-area {
    display: block !important;
  }
}
.loan-card .bottom-side .collapse-installments-button {
  margin-top: 1rem;
}
.loan-card .bottom-side .ant-collapse-header {
  display: none;
}
.loan-card .bottom-side .ant-collapse-content-box {
  padding: 0 !important;
}
.loan-card .section-divider {
  margin: 2.5rem 0rem;
  padding: none;
  background-color: #c9d3cc;
  height: 0.063rem;
  width: 100%;
}
@media (max-width: 768px) {
  .loan-card .section-divider {
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
  }
}
.loan-card #loan-details-button {
  width: fit-content;
}
.loan-card .details-btn-col {
  width: fit-content !important;
}
.loan-card .late-alert {
  margin-bottom: 1.5rem;
}
.loan-card .gyramais-information .interest-rate-tooltip {
  margin-left: 0.5rem;
}
.loan-card + .loan-card {
  margin-top: 1rem !important;
}
.aux-loan-card .ant-card-body {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/LoanCard/components/BadescLoanCard/styles.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AACF;AACE;EAAA;IAEI,uBAAA;EACJ;AACF;AAVA;EAaI,aAAA;EACA,mBAAA;AAAJ;AAdA;EAiBM,kBAAA;AAAN;AAjBA;EAuBM,iBAAA;AAHN;AApBA;EA4BI,qBAAA;AALJ;AAvBA;EAgCI,aAAA;EACA,qBAAA;EACA,yBAAA;AANJ;AAQI;EAAA;IACE,uBAAA;EALJ;EAIE;IAII,WAAA;EALN;EACE;IAQI,cAAA;EANN;EAQM;IACE,mBAAA;EANR;EALE;IAgBI,mBAAA;IACA,gBAAA;EARN;EATE;IAqBI,sBAAA;EATN;AACF;AAjDA;EA8DI,mBAAA;AAVJ;AApDA;EAkEI,aAAA;EACA,mBAAA;EACA,yBAAA;AAXJ;AAaI;EAAA;IACE,yBAAA;EAVJ;AACF;AA9DA;EA6EM,gBAAA;AAZN;AAjEA;EAgFM,aAAA;AAZN;AApEA;EAmFM,qBAAA;AAZN;AAvEA;EAwFI,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAdJ;AAgBI;EAAA;IACE,kBAAA;IACA,qBAAA;EAbJ;AACF;AApFA;EAqGI,kBAAA;AAdJ;AAvFA;EAwGI,6BAAA;AAdJ;AA1FA;EA4GI,qBAAA;AAfJ;AA7FA;EAgHM,mBAAA;AAhBN;AAhGA;EAqHI,2BAAA;AAlBJ;AAqBA;EAEI,UAAA;AApBJ","sourcesContent":[".loan-card {\n  margin: auto;\n  transition: 0.6s;\n  box-shadow: none !important;\n  border: 0.063rem solid #c9d3cc;\n\n  @media (max-width: @md-screen) {\n    .gyramais-information {\n      margin-bottom: 0.875rem;\n    }\n  }\n\n  .header-left-side {\n    display: flex;\n    align-items: center;\n\n    .title-container {\n      margin-right: 1rem;\n    }\n  }\n\n  .header-right-side {\n    .schedule-installments-button-icon {\n      font-size: 1.4rem;\n    }\n  }\n\n  .info-row {\n    align-items: flex-end;\n  }\n\n  .buttons-area {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n\n    @media (max-width: @md-screen) {\n      justify-content: center;\n\n      .ant-row {\n        width: 100%;\n      }\n\n      .ant-col {\n        flex: 0 0 100%;\n\n        &:last-child {\n          margin-bottom: 1rem;\n        }\n      }\n\n      .section-divider {\n        margin: 0.5rem 0rem;\n        margin-top: 1rem;\n      }\n\n      .gyramais-btn {\n        width: 100% !important;\n      }\n    }\n  }\n  .information-badesc-suffix {\n    margin-left: 0.6rem;\n  }\n\n  .actions-area {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    @media (max-width: @md-screen) {\n      display: block !important;\n    }\n  }\n\n  .bottom-side {\n    .collapse-installments-button {\n      margin-top: 1rem;\n    }\n    .ant-collapse-header {\n      display: none;\n    }\n    .ant-collapse-content-box {\n      padding: 0 !important;\n    }\n  }\n\n  .section-divider {\n    margin: 2.5rem 0rem;\n    padding: none;\n    background-color: #c9d3cc;\n    height: 0.063rem;\n    width: 100%;\n\n    @media (max-width: @md-screen) {\n      margin-top: 0.5rem;\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  #loan-details-button {\n    width: fit-content;\n  }\n  .details-btn-col {\n    width: fit-content !important;\n  }\n\n  .late-alert {\n    margin-bottom: 1.5rem;\n  }\n  .gyramais-information {\n    .interest-rate-tooltip {\n      margin-left: 0.5rem;\n    }\n  }\n\n  + .loan-card {\n    margin-top: 1rem !important;\n  }\n}\n.aux-loan-card {\n  .ant-card-body {\n    padding: 0;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
